<div class="main-content">
	<div class="container-fluid">
		<div class="card">
			<div class="card-header card-header-{{color}}-6 d-flex justify-content-between align-items-center">
				<h4 class="card-title m-0">
					<i class="material-icons" (click)="back()">arrow_left</i> Create User
				</h4>
				<p class="card-category m-0">User Information</p>
			</div>

			<div class="row py-3 px-4">
				<div class="col-6 text-left">
					<button mat-raised-button color="accent" class="back-btn" (click)="back()">Cancel</button>
				</div>
				<div class="col-6 text-right">
					<button mat-raised-button color="primary" class="create-btn" [disabled]="loading || !userForm.valid || !systemForm.valid || user.locations.length < 1 || activeStep !== 2" (click)="createUser()">
						<mat-spinner *ngIf="loading" diameter="20" strokeWidth="3" class="mr-2"></mat-spinner>
						<span *ngIf="!loading">Create User</span>
					</button>
				</div>
			</div>

			<div class="card-body d-flex flex-wrap gap-4">
			  <div class="flex-grow-1 min-w-50">
				<mat-stepper orientation="vertical" linear class="w-100" (selectionChange)="logStep($event)">
				  
				  <!-- Step 1: User Information -->
				  <mat-step [stepControl]="userForm">
					<ng-template matStepLabel>User Information</ng-template>
					<form [formGroup]="userForm" class="form-grid">
					  <ng-container *ngFor="let field of [
						{ label: 'User ID', name: 'userid' },
						{ label: 'Password', name: 'password' },
						{ label: 'Name', name: 'realname' },
						{ label: 'Email Address', name: 'email', type: 'email', placeholder: 'Email address' },
						{ label: 'Phone #', name: 'phone', type: 'text', placeholder: '(123) 456-7890' },
					  ]">
						<mat-form-field class="form-field" appearance="outline">
						  <mat-label>{{ field.label }}</mat-label>
						  <input matInput [type]="field.type || 'text'" [placeholder]="field.placeholder"
								 formControlName="{{field.name}}" *ngIf="field.name !== 'phone'; else phoneField">
						  <ng-template #phoneField>
							<input matInput type="text" (input)="format_phone($event.target)" 
								   [placeholder]="field.placeholder" formControlName="phone">
						  </ng-template>
						</mat-form-field>
					  </ng-container>
					</form>
					<button mat-raised-button color="primary" matStepperNext [disabled]="!userForm.valid">Next</button>
				  </mat-step>
			
				  <!-- Step 2: System Information -->
				  <mat-step [stepControl]="systemForm">
					<ng-template matStepLabel>System Information</ng-template>
					<button mat-button matStepperPrevious>Previous</button>
			
					<form [formGroup]="systemForm" class="form-grid">
					  <mat-form-field appearance="outline" class="form-field">
						<mat-label>Default Location</mat-label>
						<mat-select formControlName="defaultlocation" (selectionChange)="defaultLocation($event)">
						  <mat-option *ngFor="let loc of recs" [value]="loc.loccode">{{ loc.loccode }} {{ loc.locationname }}</mat-option>
						</mat-select>
					  </mat-form-field>
			
					  <mat-form-field class="form-field" appearance="outline">
						<mat-label>Full Access</mat-label>
						<input matInput placeholder="Y/N" formControlName="fullaccess">
					  </mat-form-field>
			
					  <div class="toggle-row">
						<mat-slide-toggle formControlName="isPOSUser" color="primary">POS User</mat-slide-toggle>
					  </div>
					  <mat-form-field *ngIf="systemForm.get('isPOSUser')?.value" class="form-field" appearance="outline">
						<mat-label>Employee Code</mat-label>
						<input matInput placeholder="Employee Code" formControlName="empcode">
						<mat-error *ngIf="systemForm.get('empcode').errors">Code "{{systemForm.get('empcode').value}}" is already in use for {{empcodes[systemForm.get('empcode').value] | uppercase}}</mat-error>
					  </mat-form-field>
			
					  <div class="toggle-row">
						<mat-slide-toggle formControlName="isSalesman" color="primary">Salesman</mat-slide-toggle>
					  </div>
			
					  <!-- Salesman Section -->
					  <div *ngIf="systemForm.get('isSalesman')?.value" class="salesman-section stacked-section">
						<mat-card class="rounded shadow-sm p-4 mb-4">
						  <mat-card-title class="text-primary text-lg font-semibold mb-2">Salesman Setup</mat-card-title>
						  <mat-card-content class="form-grid-cols1">
							<mat-form-field class="form-field w-full">
							  <mat-label>Salesman Code</mat-label>
							  <input matInput placeholder="Salesman Code" formControlName="salesman">
							  <mat-hint *ngIf="systemForm.get('salesman')?.value">
								<mat-icon color="accent" inline style="font-size: 16px;">info</mat-icon>
								A new salesman record will be created.
							  </mat-hint>
							</mat-form-field>
			
							<mat-form-field class="form-field w-full">
							  <mat-label>Commission Rate (%)</mat-label>
							  <input matInput type="number" placeholder="e.g. 5.5" formControlName="commissionrate1">
							</mat-form-field>
			
							<mat-form-field class="form-field w-full">
							  <mat-label>CSR Emails</mat-label>
							  <input matInput placeholder="Separate with commas" formControlName="csremails">
							</mat-form-field>
			
							<mat-form-field class="form-field d-none w-full">
							  <mat-label>Commission Lock</mat-label>
							  <mat-select formControlName="commlock">
								<mat-option [value]="0">Unlocked</mat-option>
								<mat-option [value]="1">Locked</mat-option>
							  </mat-select>
							</mat-form-field>
						  </mat-card-content>
						</mat-card>
			
						<mat-card class="rounded shadow-sm p-4 mb-4">
						  <mat-card-title class="text-primary text-lg font-semibold mb-2">Telegram Setup</mat-card-title>
						  <mat-card-content class="form-grid-cols1">
							<mat-form-field class="form-field w-full">
							  <mat-label>Chat ID</mat-label>
							  <input matInput placeholder="Optional Chat ID" formControlName="chatid">
							</mat-form-field>
			
							<mat-form-field class="form-field w-full">
							  <mat-label>Group ID</mat-label>
							  <input matInput type="number" formControlName="group_id">
							</mat-form-field>
			
							<mat-form-field class="form-field w-full">
							  <mat-label>Group Level</mat-label>
							  <input matInput type="number" formControlName="group_level">
							</mat-form-field>
			
							<mat-form-field class="form-field w-full">
							  <mat-label>Group Type</mat-label>
							  <input matInput type="number" formControlName="group_type">
							</mat-form-field>
						  </mat-card-content>
						</mat-card>
					  </div>
			
					  <!-- User Group -->
					  <mat-form-field appearance="outline" class="form-field">
						<mat-label>User Group</mat-label>
						<mat-select formControlName="user_group">
						  <mat-option *ngFor="let ug of usergroups" [value]="ug.user_group_id">{{ ug.name }}</mat-option>
						</mat-select>
					  </mat-form-field>
			
					  <!-- Permissions -->
					  <ng-container *ngFor="let perm of [
						{ label: 'Customer Admin', name: 'customeradmin' },
						{ label: 'Create Tender', name: 'cancreatetender' },
						{ label: 'Edit Invoice', name: 'editinv' },
						{ label: 'Dispatch Admin', name: 'dispatchadmin' }
					  ]">
						<mat-form-field appearance="outline" class="form-field">
						  <mat-label>{{ perm.label }}</mat-label>
						  <mat-select formControlName="{{perm.name}}">
							<mat-option *ngFor="let yn of yesno" [value]="yn.value">{{ yn.name }}</mat-option>
						  </mat-select>
						</mat-form-field>
					  </ng-container>
					</form>
			
					<button mat-raised-button color="primary" matStepperNext [disabled]="!systemForm.valid">Next</button>
				  </mat-step>
			
				  <!-- Step 3: Location Access -->
				  <mat-step>
					<ng-template matStepLabel>Location Access</ng-template>
					<button mat-button matStepperPrevious>Previous</button>
			
					<div class="locations-access-grid">
					  <div class="location-column">
						<h5 class="section-subtitle">Available Locations</h5>
						<mat-divider></mat-divider>
						<mat-nav-list class="perm-box tight-list">
						  <button mat-list-item *ngFor="let loc of locations" (click)="addUserLocation(loc)">
							<div class="loc-text"><strong>{{ loc.loccode }}</strong>: {{ loc.locationname }}</div>
							<mat-icon class="loc-icon" color="primary">add</mat-icon>
						  </button>
						</mat-nav-list>
					  </div>
			
					  <div class="location-column">
						<h5 class="section-subtitle">Assigned Access</h5>
						<mat-divider></mat-divider>
						<mat-nav-list class="perm-box tight-list">
						  <button mat-list-item *ngFor="let loc of user.locations" (click)="removeUserLocation(loc)">
							<div class="loc-text"><strong>{{ loc.loccode }}</strong>: {{ loc.locationname }}</div>
							<mat-icon class="loc-icon" color="warn">remove</mat-icon>
						  </button>
						</mat-nav-list>
					  </div>
					</div>
			
					<div class="text-right mt-3">
					  <button mat-raised-button color="primary" class="create-btn"
							  [disabled]="loading || !userForm.valid || !systemForm.valid || user.locations.length < 1 || activeStep !== 2"
							  (click)="createUser()">
						<mat-spinner *ngIf="loading" diameter="20" strokeWidth="3" class="mr-2"></mat-spinner>
						<span *ngIf="!loading">Create User</span>
					  </button>
					</div>
				  </mat-step>
				</mat-stepper>
			  </div>
			
			  <mat-divider [vertical]="true"></mat-divider>
			
			  <!-- Review Sidebar -->
			  <div class="review-container card shadow-sm p-4 rounded">
				<div class="section">
				  <h4 class="section-title">User</h4>
				  <ul class="entry-list">
					<li *ngFor="let field of [
					  { label: 'User ID', key: 'userid' },
					  { label: 'Password', key: 'password' },
					  { label: 'Name', key: 'realname' },
					  { label: 'Email Address', key: 'email' },
					  { label: 'Phone #', key: 'phone' },
					]">
					  <div class="spec-label">{{ field.label }}</div>
					  <div class="spec-value" [ngClass]="{'bg-danger text-white' : userForm.get(field.key).value && userForm.get(field.key).errors}">
						{{ userForm.get(field.key).value || '?' }}
						
						<ng-container *ngIf="userForm.get(field.key).errors">
							&nbsp;{{userForm.get(field.key).errors.error}}
						</ng-container>

					  </div>
					</li>
				  </ul>
				</div>
			
				<div class="section">
				  <h4 class="section-title">System</h4>
				  <ul class="entry-list">
					<li><div class="spec-label">Default Location</div><div class="spec-value">{{ systemForm.get('defaultlocation').value || '?' }}</div></li>
					<li><div class="spec-label">Full Access</div><div class="spec-value">{{ systemForm.get('fullaccess').value || '?' }}</div></li>
					<li><div class="spec-label">User Group</div><div class="spec-value">{{ translate_usergroup(systemForm.get('user_group').value) || '?' }}</div></li>
					<li><div class="spec-label">Customer Admin</div><div class="spec-value">{{ translate_yn(systemForm.get('customeradmin').value) || '?' }}</div></li>
					<li><div class="spec-label">Create Tender</div><div class="spec-value">{{ translate_yn(systemForm.get('cancreatetender').value) || '?' }}</div></li>
					<li><div class="spec-label">Edit Invoices</div><div class="spec-value">{{ translate_yn(systemForm.get('editinv').value) || '?' }}</div></li>
					<li><div class="spec-label">Dispatch Admin</div><div class="spec-value">{{ translate_yn(systemForm.get('dispatchadmin').value) || '?' }}</div></li>
				  </ul>
				</div>
			
				<div class="section">
				  <h4 class="section-title">Locations</h4>
				  <ul class="entry-list">
					<ng-container *ngIf="user.locations?.length; else noLocations">
					  <li *ngFor="let loc of user.locations">
						<div class="spec-label">{{ loc.loccode }}</div>
						<div class="spec-value">{{ loc.locationname }}</div>
					  </li>
					</ng-container>
					<ng-template #noLocations>
					  <li><div class="spec-label">Location</div><div class="spec-value missing">?</div></li>
					</ng-template>
				  </ul>
				</div>
			  </div>
			</div>
		</div>
	</div>
</div>